export const URLS = {
  AUTH_EMPLOYEE_MANAGEMENT: 'volumetry/employee/employeeManagement',
  AUTH_EMPLOYEE_EVALUATION_REPORTS: 'volumetry/employee/evaluationReports',
  AUTH_TASK_MANAGEMENT: 'volumetry/tasksManagement/taskManagement',
  AUTH_TASK_ALLOCATIONS: 'volumetry/tasksManagement/taskAllocations',
  AUTH_ASSIGNED_TASKS: 'volumetry/tasksManagement/assignedTasks',
  AUTH_ALLOCATED_EMPLOYEES_STATUS: 'volumetry/employee/allocatedEmployeesStatus',
  AUTH_TASK_ALLOCATION: 'volumetry/tasksManagement/taskAllocation',
  AUTH_LOCATION_MANAGEMENT: 'volumetry/tasksManagement/locationManagement',
  AUTH_LOCATION_CATEGORY_MANAGEMENT: 'volumetry/tasksManagement/locationCategoryManagement',
  AUTH_REPORTS_LINKS: 'volumetry/reports/reportsLinks'
}
